module.exports = __webpack_public_path__ + "static/media/focus-productivity-procrastination-large@3x.dcceddae.png";